import { render, staticRenderFns } from "./FAB.vue?vue&type=template&id=0761666e&scoped=true&"
import script from "./FAB.vue?vue&type=script&lang=js&"
export * from "./FAB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0761666e",
  null
  
)

export default component.exports
import {QHeader,QToolbar,QToolbarTitle,QCard,QCardSection,QSpace,QSelect,QIcon,QInput,QBtn,QBtnDropdown,QPopupProxy,QDate,QSeparator,QChip,QTable,QToggle,QTr,QTh,QTd,QTooltip,QInnerLoading,ClosePopup} from 'quasar'
component.options.components = Object.assign({QHeader,QToolbar,QToolbarTitle,QCard,QCardSection,QSpace,QSelect,QIcon,QInput,QBtn,QBtnDropdown,QPopupProxy,QDate,QSeparator,QChip,QTable,QToggle,QTr,QTh,QTd,QTooltip,QInnerLoading}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
